$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function () {

    var el = $('.m-visibility-check');

    el.each(function () {
        if ($(this).isInViewport()) {
            $(this).addClass('is-visible');
        } else {
            if ($(this).hasClass('m-visibility-check--loop')) {
                $(this).removeClass('is-visible');
            }
        }
    });
});